export enum DSVSourceType {
    DSV_AIR = 'dsv-air',
    DSV_AIR_SEA_INC = 'dsv-air-sea-inc',
    DSV_ROAD = 'dsv-road',
    DSV_ROAD_TRANSPORT = 'dsv-road-transport',
    DSV_SOLUTIONS = 'dsv-solutions',
}
